function normalizeLocale(locale) {
  const value = locale && typeof locale === 'object' && 'value' in locale
    ? locale.value
    : locale;

  return String(value || '').replace('_', '-') || undefined;
}

function createCollator(locale, sensitivity) {
  const options = {
    sensitivity,
    numeric: true,
  };

  try {
    return new Intl.Collator(normalizeLocale(locale), options);
  } catch (error) {
    return new Intl.Collator(undefined, options);
  }
}

function optionText(option, key) {
  return String(option?.[key] ?? '');
}

export function sortOptionsByLabel(options, locale) {
  const labelCollator = createCollator(locale, 'base');
  const tieCollator = createCollator(locale, 'variant');

  return (Array.isArray(options) ? options : [])
    .map((option, index) => ({ option, index }))
    .sort((left, right) => {
      const labelComparison = labelCollator.compare(
        optionText(left.option, 'label'),
        optionText(right.option, 'label')
      );
      if (labelComparison !== 0) {
        return labelComparison;
      }

      const exactLabelComparison = tieCollator.compare(
        optionText(left.option, 'label'),
        optionText(right.option, 'label')
      );
      if (exactLabelComparison !== 0) {
        return exactLabelComparison;
      }

      const valueComparison = tieCollator.compare(
        optionText(left.option, 'value'),
        optionText(right.option, 'value')
      );

      return valueComparison || left.index - right.index;
    })
    .map(({ option }) => option);
}
